import { Box, Flex, HStack, Spacer } from '@chakra-ui/react';
import { UserDetail } from '@diamond/shared/types';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { Avatar, Button, Checkbox, Divider, Text } from '@diamond/shared/ui';
import { useForm } from 'react-hook-form';
interface UserDetailProps {
  userDetail: UserDetail;
  isAdmin: boolean;
  onOpenEditUser: () => void;
  onOpenDeleteUser: () => void;
  hideButton: boolean;
}
export function UserDetailCard({
  userDetail,
  isAdmin,
  onOpenEditUser,
  onOpenDeleteUser,
  hideButton,
}: UserDetailProps) {
  const method = useForm();
  const shipTos = userDetail?.shiptos ?? [];

  return (
    <Box p="2" border="2px" borderColor="gray.33" rounded="lg">
      <Flex w="full" rounded="lg" p="4">
        <Avatar
          size="xl"
          name={`${userDetail?.first_name} ${userDetail?.last_name}`}
          src=""
        />
        <Box py="2" px={8} w="full" alignSelf="center">
          <Text fontWeight="bold" fontSize="xl">
            {`${userDetail?.first_name} ${userDetail?.last_name}`}
          </Text>
          <Text color="blue" as="u">
            {userDetail?.email}
          </Text>
        </Box>
      </Flex>
      <Divider borderWidth="2px" my="4" />
      <Flex px="4">
        <Box w="40%" fontWeight="semibold" color="gray.75">
          <Text>Email</Text>
          <Text>Nama Depan</Text>
          <Text>Nama Belakang</Text>
          <Text>Nomor Bill To</Text>
          <Text>Nama Perusahaan</Text>
        </Box>
        <Box w="full">
          <Text>: {userDetail?.email}</Text>
          <Text>: {userDetail?.first_name}</Text>
          <Text>: {userDetail?.last_name}</Text>
          <Text>: {userDetail?.bil_to_number}</Text>
          <Text>: {userDetail?.company_name}</Text>
        </Box>
      </Flex>
      <Box p="4" w="full" h="300px" overflowY="auto">
        <Text>Ship to</Text>
        {shipTos.map((val) => (
          <Checkbox
            key={val.id}
            name="shipto"
            isDisabled
            isChecked={val.is_selected}
            register={method.register}
            alignItems="start"
            mt="1"
          >
            <Text mt="-0.2rem">{val.name}</Text>
          </Checkbox>
        ))}
      </Box>
      {!isAdmin && !hideButton && userDetail.status === 'active' && (
        <HStack>
          <Spacer />
          <Button onClick={onOpenEditUser}>Ubah Shipto</Button>
          {userDetail && userDetail?.request_admin_status !== 'waiting' && (
            <Button variant="solid" bgColor="red" onClick={onOpenDeleteUser}>
              Remove User
            </Button>
          )}
        </HStack>
      )}
    </Box>
  );
}
